import Link from 'next/link';
import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const NavItem = styled(Link).attrs({ scroll: false })<{
  $isActive: boolean;
}>`
  display: grid;
  grid-template-columns: 24px 1fr;
  align-items: center;
  gap: 10px;
  min-height: 50px;
  height: 50px;
  padding: 13px 15px;
  border-radius: 14px;
  color: ${({ theme }) => theme.palette.primary.labels};

  &:hover {
    color: ${({ theme }) => theme.palette.system.blue};
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      color: ${({ theme }) => theme.palette.system.deepBlue};
      background-color: ${({ theme }) => theme.palette.secondary.border};
    `}
`;

export const NavTitle = styled(Typography.Body).attrs({ $variant: '2' })`
  color: currentColor;
  font-size: 16px;
`;

export const SectionTitle = styled(Typography.Text)`
  padding: 5px 15px;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const Divider = styled.div`
  height: 1px;
  margin: 5px 0;
  background-color: ${({ theme }) => theme.palette.secondary.border};
`;

export const LogoutButton = styled.button`
  display: grid;
  grid-template-columns: 22px 1fr;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  padding: 0 14px;
  color: ${({ theme }) => theme.palette.primary.labels};
  background: transparent;
  border: 0;
  cursor: pointer;
  text-align: left;

  &:hover {
    color: ${({ theme }) => theme.palette.system.blue};
  }
`;
